export default __webpack_public_path__ + "static/azure-0c2598603934c18493c2bf90406199dd.svg";